import { NavigationExtras } from '@angular/router';

import { IDocument } from '../../models/IDocument';

export const EDIT_PROJECT_COMPONENT_CAN_DEACTIVATE_EXCEPTION_KEY = 'hasAlreadyConfirmedLeavingEditProject';

export const ALREADY_CONFIRMED_LEAVING_PROJECT_NAVIGATION_EXTRAS: NavigationExtras = {
    state: { [EDIT_PROJECT_COMPONENT_CAN_DEACTIVATE_EXCEPTION_KEY]: true }
};

export const PERIOD_UNIT_MONTHS_13 = 'Months13';

export const DOCUMENT_ELEMENT_ID_PREFIX = 'document-';

export const DocumentIdKey = {
    DocumentId: 'documentId',
    HypoDossierDocumentId: 'hypoDossierDocumentId'
} as const satisfies Record<string, Extract<'documentId' | 'hypoDossierDocumentId', keyof IDocument>>;
